var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _g2, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _g3, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _g4, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _g5, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _g6, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _g7, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _g8, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _g9, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _g10, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 433,
    viewBox: "0 0 400 433",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360.177 244.241C360.194 255.816 356.005 267.002 348.389 275.718L348.374 275.739C347.875 276.306 347.37 276.86 346.852 277.402L346.651 277.605C331.084 293.634 306.506 296.781 287.403 285.192C268.299 273.602 259.737 250.35 266.762 229.139C267.297 227.527 267.919 225.946 268.625 224.402C273.833 212.987 283.297 204.06 294.997 199.528L295.63 199.29C296.455 198.986 297.286 198.703 298.133 198.444C298.559 198.313 298.982 198.188 299.411 198.07C313.842 194.062 329.316 197.029 341.241 206.09C353.166 215.151 360.171 229.264 360.177 244.241Z",
    fill: "#62A3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.538 202.657C314.802 202.951 315.173 203.125 315.567 203.141C316.83 203.166 317.296 201.51 319.451 202.405C322.008 203.464 320.891 208.895 319.491 210.015C318.09 211.135 319.296 213.501 317.36 214.046C315.424 214.591 313.813 211.562 313.509 209.82C313.341 208.852 312.863 208.326 312.27 208.055C311.548 207.734 310.926 207.224 310.471 206.578C310.471 206.578 308.994 203.683 311.04 202.143C312.632 200.943 314.011 202.097 314.538 202.657Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M288.577 226.971C288.905 226.266 289.581 225.786 290.355 225.709C291.129 225.631 291.887 225.968 292.349 226.594C292.349 226.612 292.376 226.63 292.388 226.652C293.764 228.618 293.764 227.242 294.726 227.93C295.688 228.618 295.691 229.388 294.726 230.034C293.761 230.679 292.251 230.947 291.015 231.781C289.779 232.615 286.753 230.259 287.715 228.615C288.078 227.994 288.361 227.446 288.577 226.971Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.74 269.225C310.21 268.212 311.179 267.523 312.29 267.411C313.4 267.299 314.487 267.782 315.15 268.68C315.168 268.707 315.189 268.735 315.208 268.765C317.18 271.584 317.18 269.615 318.556 270.592C319.932 271.569 319.841 274.503 318.462 275.429C317.083 276.354 315.01 274.93 313.235 276.111C311.46 277.292 307.125 273.94 308.504 271.575C309.028 270.692 309.436 269.885 309.74 269.225Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.722 247.355C300.725 248.613 302.057 249.569 303.57 250.116C309.999 252.39 300.203 255.063 300.696 258.625C301.189 262.187 294.266 264.762 294.266 264.762C294.266 264.762 288.693 268.881 289.585 272.15C290.476 275.42 290.266 275.736 288.483 276.823C286.699 277.91 285.186 279.259 283.396 277.374C281.393 275.262 283.173 275.152 282.084 273.468C280.994 271.785 278.817 270.303 280.598 268.126C282.379 265.949 278.421 260.193 281.207 259.602C283.992 259.012 284.075 256.64 282.787 255.453C281.499 254.266 274.759 252.39 275.064 245.76C275.368 239.13 278.324 241.306 278.412 238.637C278.501 235.967 275.064 234.448 272.166 233.985C269.831 233.611 268.096 231.212 266.762 229.139C267.297 227.527 267.919 225.946 268.625 224.402C273.833 212.987 283.297 204.06 294.997 199.528L295.63 199.29C296.467 198.986 297.305 198.7 298.133 198.444C298.559 198.313 298.988 198.188 299.411 198.07C299.767 199.421 299.737 201.217 298.97 203.595C298.385 205.394 295.755 205.421 296.014 207.248C296.102 207.756 296.407 208.201 296.85 208.467C297.292 208.733 297.828 208.794 298.318 208.633C299.205 208.391 299.952 207.791 300.379 206.977C301.369 204.998 305.107 205.79 306.3 208.347C306.842 209.513 309.086 212.913 303.743 214.895C298.401 216.877 296.519 212.916 294.145 215.686C291.77 218.457 286.425 216.082 286.129 220.435C285.834 224.789 282.674 219.437 280.994 219.227C280.309 219.205 279.629 219.338 279.003 219.617C276.714 220.53 276.427 223.574 278.361 225.096C278.918 225.534 279.243 226.28 278.817 227.55C277.73 230.816 278.997 235.663 284.449 234.871C289.901 234.08 288.516 237.842 292.869 238.524C295.305 238.911 296.343 241.76 297.904 244.597",
    fill: "#9AF3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M299.722 247.355C300.725 248.613 302.057 249.569 303.57 250.116C309.999 252.39 300.203 255.063 300.696 258.625C301.189 262.187 294.266 264.762 294.266 264.762C294.266 264.762 288.693 268.881 289.585 272.15C290.476 275.42 290.266 275.736 288.483 276.823C286.699 277.91 285.186 279.259 283.396 277.374C281.393 275.262 283.173 275.152 282.084 273.468C280.994 271.785 278.817 270.303 280.598 268.126C282.379 265.949 278.421 260.193 281.207 259.602C283.992 259.012 284.075 256.64 282.787 255.453C281.499 254.266 274.759 252.39 275.064 245.76C275.368 239.13 278.324 241.306 278.412 238.637C278.501 235.967 275.064 234.448 272.166 233.985C269.831 233.611 268.096 231.212 266.762 229.139C267.297 227.527 267.919 225.946 268.625 224.402C273.833 212.987 283.297 204.06 294.997 199.528L295.63 199.29C296.467 198.986 297.305 198.7 298.133 198.444C298.559 198.313 298.988 198.188 299.411 198.07C299.767 199.421 299.737 201.217 298.97 203.595C298.385 205.394 295.755 205.421 296.014 207.248C296.102 207.756 296.407 208.201 296.85 208.467C297.292 208.733 297.828 208.794 298.318 208.633C299.205 208.391 299.952 207.791 300.379 206.977C301.369 204.998 305.107 205.79 306.3 208.347C306.842 209.513 309.086 212.913 303.743 214.895C298.401 216.877 296.519 212.916 294.145 215.686C291.77 218.457 286.425 216.082 286.129 220.435C285.834 224.789 282.674 219.437 280.994 219.227C280.309 219.205 279.629 219.338 279.003 219.617C276.714 220.53 276.427 223.574 278.361 225.096C278.918 225.534 279.243 226.28 278.817 227.55C277.73 230.816 278.997 235.663 284.449 234.871C289.901 234.08 288.516 237.842 292.869 238.524C295.305 238.911 296.343 241.76 297.904 244.597",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.303 245.276C278.303 245.276 277.35 248.853 281.183 251.002",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M329.64 288.9C316.816 293.876 302.475 293.117 290.248 286.814V286.796C290.248 286.711 294.242 282.081 297.676 283.356C301.11 284.632 302.06 290.02 305.524 287.645C308.988 285.271 313.743 287.496 316.523 286.732C319.302 285.968 322.553 282.242 326.024 284.525C329.494 286.808 329.64 288.9 329.64 288.9Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M320.727 287.052C320.727 287.052 322.337 286.05 323.616 286.032C324.276 285.995 324.912 286.289 325.311 286.817",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M333.817 225.239C333.587 225.627 333.295 225.973 332.952 226.265C331.865 227.057 329.448 227.078 328.27 226.341C326.425 225.19 327.789 223.367 327.333 222.012C325.543 216.658 333.05 218.944 332.952 216.371C332.855 213.799 329.786 214.292 328.103 212.314C326.419 210.335 330.182 206.968 333.546 208.158C335.814 208.956 339.26 207.272 341.263 206.091C351.821 214.119 358.579 226.164 359.93 239.358C361.282 252.553 357.104 265.717 348.392 275.718L348.377 275.739C347.814 276.315 347.296 276.857 346.818 277.35C346.179 276.367 344.1 276.132 343.001 276.363C339.086 277.182 336.304 280.793 332.258 279.012C328.212 277.231 334.042 275.152 332.456 269.709C330.87 264.266 339.978 264.96 336.91 261.395C333.841 257.83 337.604 253.876 336.219 251.301C334.833 248.725 328.894 251.605 328.401 249.322C327.908 247.039 322.459 245.861 321.171 243.885C319.883 241.909 324.538 238.539 323.549 236.661C322.559 234.783 321.792 234.08 325.454 230.621C329.116 227.163 330.964 230.271 334.824 229.662C338.684 229.054 339.47 230.104 340.56 231.489C341.649 232.874 343.056 231.118 344.036 231.614C345.016 232.11 346.803 233.483 346.605 230.317C346.408 227.151 341.89 226.426 340.986 226.423C338.292 226.423 340.377 226.259 338.292 226.423C336.206 226.588 337.302 224.092 336.115 223.3C335.257 222.728 334.55 224.125 333.814 225.242",
    fill: "#9AF3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M333.817 225.239C333.587 225.627 333.295 225.973 332.952 226.265C331.865 227.057 329.448 227.078 328.27 226.341C326.425 225.19 327.789 223.367 327.333 222.012C325.543 216.658 333.05 218.944 332.952 216.371C332.855 213.799 329.786 214.292 328.103 212.314C326.419 210.335 330.182 206.968 333.546 208.158C335.814 208.956 339.26 207.272 341.263 206.091C351.821 214.119 358.579 226.164 359.93 239.358C361.282 252.553 357.104 265.717 348.392 275.718L348.377 275.739C347.814 276.315 347.296 276.857 346.818 277.35C346.179 276.367 344.1 276.132 343.001 276.363C339.086 277.182 336.304 280.793 332.258 279.012C328.212 277.231 334.042 275.152 332.456 269.709C330.87 264.266 339.978 264.96 336.91 261.395C333.841 257.83 337.604 253.876 336.219 251.301C334.833 248.725 328.894 251.605 328.401 249.322C327.908 247.039 322.459 245.861 321.171 243.885C319.883 241.909 324.538 238.539 323.549 236.661C322.559 234.783 321.792 234.08 325.454 230.621C329.116 227.163 330.964 230.271 334.824 229.662C338.684 229.054 339.47 230.104 340.56 231.489C341.649 232.874 343.056 231.118 344.036 231.614C345.016 232.11 346.803 233.483 346.605 230.317C346.408 227.151 341.89 226.426 340.986 226.423C338.292 226.423 340.377 226.259 338.292 226.423C336.206 226.588 337.302 224.092 336.115 223.3C335.257 222.728 334.55 224.125 333.814 225.242",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M344.995 247.023L349.577 252.938",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M344.605 250.016L347.287 253.477",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M348.864 247.352L344.736 252.68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.534 249.982L347.5 252.607",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M354.192 228.177C354.488 228.947 354.737 229.735 354.937 230.536",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M349.577 219.906C351.101 221.986 352.417 224.211 353.507 226.548",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M350.989 199.156C355.724 199.156 359.562 195.318 359.562 190.584C359.562 185.85 355.724 182.012 350.989 182.012C346.255 182.012 342.417 185.85 342.417 190.584C342.417 195.318 346.255 199.156 350.989 199.156Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M348.304 188.191C348.256 188.426 348.096 188.622 347.875 188.715C347.549 188.878 347.186 188.953 346.822 188.931C346.409 188.923 346.033 188.689 345.844 188.322C345.637 187.899 345.765 187.193 346.149 187.104C346.275 187.094 346.401 187.106 346.523 187.138C346.781 187.157 347.04 187.117 347.281 187.022C347.281 187.022 347.933 186.843 348.173 187.226C348.363 187.51 348.412 187.867 348.304 188.191Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M355.957 189.817C355.93 189.981 355.812 190.115 355.653 190.164C355.496 190.213 355.332 190.229 355.169 190.213C354.983 190.205 354.805 190.13 354.67 190.003C354.502 189.875 354.417 189.561 354.587 189.436C354.834 189.114 355.263 189.172 355.625 189.354C355.818 189.429 355.948 189.61 355.957 189.817Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M355.957 186.234C356.209 186.614 356.413 187.023 356.566 187.452",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M352.651 184.304C353.708 184.36 354.704 184.818 355.434 185.585",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M352.953 192.49C353.408 192.911 353.575 193.56 353.379 194.149C353.266 194.517 353.257 195.184 352.886 195.592C352.643 195.829 352.338 195.992 352.006 196.064C351.469 196.215 350.913 196.287 350.356 196.277C349.989 196.293 349.625 196.206 349.306 196.024C349.015 195.806 348.789 195.514 348.651 195.178C348.584 195.035 348.517 194.873 348.462 194.733C348.112 193.836 348.527 192.822 349.406 192.429C349.691 192.29 350.018 192.267 350.319 192.365C351.391 192.742 351.93 191.61 352.953 192.49Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M351.549 193.135C351.549 193.135 352.386 192.962 352.615 193.975",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M273.388 177.194H299.338C305.371 177.198 310.262 182.08 310.266 188.103V318.469H97.4022V188.103C97.4064 182.077 102.301 177.194 108.338 177.194H263.812",
    fill: "#87D4FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.388 177.194H299.338C305.371 177.198 310.262 182.08 310.266 188.103V318.469H97.4022V188.103C97.4064 182.077 102.301 177.194 108.338 177.194H263.812",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.48 367.601L203.38 367.593L64.2871 367.601L97.1469 318.469H309.62L342.48 367.601Z",
    fill: "#62A3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M342.48 367.593V373.719C342.48 375.952 341.591 378.093 340.009 379.672C338.427 381.251 336.282 382.138 334.045 382.138H74.5168C71.8044 382.14 69.2024 381.066 67.2838 379.152C65.3651 377.238 64.2871 374.642 64.2871 371.934V367.601L342.48 367.593Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M102.78 189.137C102.78 184.997 106.143 181.64 110.291 181.64",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M304.16 189.137C304.16 184.997 300.797 181.64 296.649 181.64",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.052 351.256L313.27 360.208",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M304.685 355.387L308.538 360.171",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M311.362 344.028H95.9226C95.2104 344.079 94.5275 343.737 94.1435 343.136C93.7595 342.535 93.736 341.773 94.0824 341.149L103.238 326.109C104.133 324.693 105.699 323.842 107.377 323.86H299.908C301.584 323.841 303.148 324.693 304.039 326.109L313.21 341.149C313.557 341.774 313.533 342.538 313.147 343.14C312.761 343.741 312.076 344.082 311.362 344.028Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.362 344.028H95.9226C95.2104 344.079 94.5275 343.737 94.1435 343.136C93.7595 342.535 93.736 341.773 94.0824 341.149L103.238 326.109C104.133 324.693 105.699 323.842 107.377 323.86H299.908C301.584 323.841 303.148 324.693 304.039 326.109L313.21 341.149C313.557 341.774 313.533 342.538 313.147 343.14C312.761 343.741 312.076 344.082 311.362 344.028Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M100.895 329.963H306.39",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2145 336.831H310.071",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.513 344.058L117.636 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.595 344.058L131.253 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136.721 343.878L144.345 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M151.578 344.133L157.714 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M166.104 344.058L171.331 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M180.87 344.058L184.182 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M196.162 344.058L197.318 323.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M300.389 343.931L289.393 324.01",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M285.307 343.931L275.701 323.89",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M270.188 343.751L262.595 323.89",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M255.324 344.006L249.218 323.89",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M240.798 343.931L235.646 324.063",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M226.032 343.931L222.788 324.153",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M210.74 343.931L209.606 324.153",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M222.788 349.734H227.97C229.829 349.734 231.531 350.778 232.371 352.433L236.277 360.103C236.502 360.545 236.48 361.073 236.219 361.495C235.959 361.917 235.497 362.174 235 362.172H171.767C171.27 362.174 170.808 361.917 170.547 361.495C170.287 361.073 170.265 360.545 170.49 360.103L174.395 352.433C175.236 350.778 176.937 349.734 178.797 349.734H216.501",
    fill: "#87D4FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M222.788 349.734H227.97C229.829 349.734 231.531 350.778 232.371 352.433L236.277 360.103C236.502 360.545 236.48 361.073 236.219 361.495C235.959 361.917 235.497 362.174 235 362.172H171.767C171.27 362.174 170.808 361.917 170.547 361.495C170.287 361.073 170.265 360.545 170.49 360.103L174.395 352.433C175.236 350.778 176.937 349.734 178.797 349.734H216.501",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M298.459 187.668V195.683H108.308V187.668C108.308 187.254 108.644 186.918 109.059 186.918H297.738C298.141 186.934 298.459 187.265 298.459 187.668Z",
    fill: "#9AF3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M298.459 195.683V307.396C298.459 307.81 298.123 308.145 297.708 308.145H109.029C108.614 308.145 108.278 307.81 108.278 307.396V195.683H298.459Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M140.529 191.312H147.139",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M121.595 191.312H136.721",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M174.523 206.824H121.595V259.659H174.523V206.824Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.595 206.824L174.523 259.651",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M160.688 220.634L174.523 206.824",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M121.595 259.652L157.879 223.439",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M284.128 206.824H188.628V259.494H284.128V206.824Z",
    fill: "#C0FF97",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M284.128 254.996V259.494H279.622",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M270.015 259.487H197.942",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M193.135 259.494H188.628V254.996",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M188.628 246.253V215.686",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M188.628 211.323V206.824H193.135",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M202.749 206.824H274.815",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M279.622 206.824H284.128V211.323",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M284.128 220.057V250.624",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M258.945 223.409H273.005",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M200.646 223.409H252.267",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M200.646 233.155H273.005",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M222.788 242.902H273.005",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M200.646 242.902H216.501",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M284.128 270.793H121.595V293.225H284.128V270.793Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M198.167 277.533L205.385 286.485",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M203.042 277.758L204.822 279.97",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8 281.657L200.653 286.44",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M304.25 164.308V245.339C297.639 240.719 290.72 236.554 283.543 232.873C282.495 230.55 281.517 228.035 281.021 226.718C280.795 226.13 280.335 225.662 279.751 225.426L258.643 216.899C258.053 216.661 257.39 216.683 256.817 216.96C254.617 218.033 252.323 218.902 249.964 219.556C231.986 214.382 213.367 211.77 194.659 211.798C187.304 211.797 179.954 212.195 172.643 212.992C170.058 211.662 167.012 210.011 165.339 209.09C164.504 208.636 163.531 208.504 162.605 208.719C157.114 209.989 141.782 213.544 136.883 214.677C135.921 214.899 135.081 215.48 134.536 216.303C133.084 218.506 131.493 220.614 129.772 222.613C121.097 225.618 112.655 229.261 104.517 233.511V164.308H304.25Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M304.25 245.339V307.337C304.25 309.273 302.679 310.843 300.741 310.844H108.026C106.094 310.836 104.533 309.268 104.533 307.337V233.511C112.661 229.262 121.092 225.62 129.757 222.613C131.477 220.614 133.069 218.506 134.52 216.303C135.065 215.48 135.905 214.899 136.867 214.677C141.773 213.544 157.104 210.001 162.589 208.719C163.515 208.504 164.488 208.636 165.323 209.09C167.009 210.011 170.054 211.662 172.627 212.992C179.938 212.195 187.288 211.796 194.643 211.798C213.351 211.77 231.97 214.382 249.948 219.556C252.307 218.902 254.601 218.033 256.801 216.96C257.374 216.683 258.037 216.661 258.627 216.899L279.738 225.413C280.322 225.649 280.782 226.117 281.008 226.705C281.504 228.023 282.482 230.537 283.53 232.861C290.712 236.545 297.635 240.714 304.25 245.339Z",
    fill: "#7774FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M304.25 156.347V164.309H104.517V156.395C104.513 155.631 104.814 154.898 105.354 154.358C105.894 153.819 106.628 153.517 107.391 153.522H301.418C302.168 153.52 302.889 153.817 303.42 154.347C303.952 154.877 304.25 155.597 304.25 156.347Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M116.365 160.429C117.191 160.429 117.861 159.76 117.861 158.934C117.861 158.108 117.191 157.439 116.365 157.439C115.539 157.439 114.87 158.108 114.87 158.934C114.87 159.76 115.539 160.429 116.365 160.429Z",
    fill: "#FF5986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M122.989 160.397C123.816 160.397 124.485 159.728 124.485 158.902C124.485 158.076 123.816 157.407 122.989 157.407C122.163 157.407 121.494 158.076 121.494 158.902C121.494 159.728 122.163 160.397 122.989 160.397Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M129.614 160.429C130.44 160.429 131.109 159.76 131.109 158.934C131.109 158.108 130.44 157.439 129.614 157.439C128.788 157.439 128.118 158.108 128.118 158.934C128.118 159.76 128.788 160.429 129.614 160.429Z",
    fill: "#53F2D4",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M186.696 157.435H150.57C149.754 157.435 149.093 158.097 149.093 158.913C149.093 159.729 149.754 160.391 150.57 160.391H186.696C187.513 160.391 188.174 159.729 188.174 158.913C188.174 158.097 187.513 157.435 186.696 157.435Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M290.935 164.413V153.518",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M295.565 156.801L300.106 161.026",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M300.106 156.801L295.565 161.026",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M161.836 227.699C162.699 228.329 163.318 229.237 163.589 230.27C164.481 233.959 160.121 238.178 153.846 239.695C147.571 241.213 141.779 239.454 140.871 235.768C139.963 232.083 144.339 227.861 150.614 226.343C152.714 225.816 154.893 225.673 157.044 225.921",
    fill: "#FFE483"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.836 227.699C162.699 228.329 163.318 229.237 163.589 230.27C164.481 233.959 160.121 238.178 153.846 239.695C147.571 241.213 141.779 239.454 140.871 235.768C139.963 232.083 144.339 227.861 150.614 226.343C152.714 225.816 154.893 225.673 157.044 225.921",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M176.364 294.378C177.542 295.629 179.918 298.172 179.918 298.172",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M178.644 294.759C179.073 295.21 179.775 295.956 180.267 296.48",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M176.682 296.629C176.834 296.781 177.152 297.112 177.854 297.861",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M258.516 232.381C260.025 232.87 261.522 233.374 263.006 233.892",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M236.065 226.42C241.876 227.632 247.563 229.062 253.127 230.708",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M219.234 189.84C220.155 189.84 220.155 188.412 219.234 188.412C218.313 188.412 218.313 189.84 219.234 189.84Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M169.899 184.926C171.128 184.926 171.128 183.022 169.899 183.022C168.67 183.022 168.673 184.926 169.899 184.926Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M244.982 209.585C246.207 209.585 246.211 207.681 244.982 207.681C243.753 207.681 243.753 209.585 244.982 209.585Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.485 176.454C125.403 176.454 125.406 175.025 124.485 175.025C123.564 175.025 123.564 176.454 124.485 176.454Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M192.496 172.724C193.417 172.724 193.417 171.295 192.496 171.295C191.575 171.295 191.575 172.724 192.496 172.724Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M192.496 203.887C193.417 203.887 193.417 202.459 192.496 202.459C191.575 202.459 191.575 203.887 192.496 203.887Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M249.986 176.454C250.907 176.454 250.907 175.025 249.986 175.025C249.065 175.025 249.065 176.454 249.986 176.454Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M295.565 179.733C296.486 179.733 296.486 178.304 295.565 178.304C294.644 178.304 294.644 179.733 295.565 179.733Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M143.361 191.174C144.278 191.174 144.282 189.745 143.361 189.745C142.44 189.745 142.44 191.174 143.361 191.174Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M121.497 217.744C122.415 217.744 122.418 216.315 121.497 216.315C120.576 216.315 120.576 217.744 121.497 217.744Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M116.365 194.685C117.286 194.685 117.286 193.256 116.365 193.256C115.444 193.256 115.444 194.685 116.365 194.685Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M293.463 228.413C294.381 228.413 294.384 226.985 293.463 226.985C292.542 226.985 292.542 228.413 293.463 228.413Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M280.821 200.859C282.047 200.859 282.05 198.954 280.821 198.954C279.592 198.954 279.592 200.859 280.821 200.859Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M265.489 310.832H207.027C207.049 310.425 207.095 310.02 207.164 309.619C208.857 299.778 223.794 294.15 240.507 297.026C251.965 298.988 261.285 304.435 265.489 310.832Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M240.393 302.127C243.567 302.661 246.654 303.622 249.57 304.984",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M169.149 278.706C165.412 283.541 158.521 287.76 150.096 289.801C136.032 293.204 123.009 289.261 121.008 280.992C119.007 272.722 128.785 263.269 142.849 259.866C156.914 256.463 169.94 260.405 171.941 268.672",
    fill: "#FF81AF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M169.149 278.706C165.412 283.541 158.521 287.76 150.096 289.801C136.032 293.204 123.009 289.261 121.008 280.992C119.007 272.722 128.785 263.269 142.849 259.866C156.914 256.463 169.94 260.405 171.941 268.672",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M136.47 261.923L160.407 285.855",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M132.688 263.716L156.641 287.661",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M140.592 260.469L163.834 283.706",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M144.98 259.402L166.834 281.246",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M159.439 268.281L169.194 278.03",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M149.912 258.758L157.158 265.999",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M155.488 258.758L170.436 273.7",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M162.163 259.974L171.658 269.462",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M123.583 271.208L143.338 290.953",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M126.232 268.281L148.197 290.239",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M129.41 265.999L152.548 289.131",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M120.684 279.347L131.138 289.798",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M121.589 274.678L137.87 290.953",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M290.887 271.141C290.807 271.836 290.611 272.512 290.306 273.141C287.845 278.198 278.874 278.903 270.269 274.728C261.663 270.554 256.684 263.053 259.154 257.996C261.625 252.939 270.586 252.231 279.189 256.409C284.019 258.758 287.706 262.148 289.576 265.564",
    fill: "#FF5986"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M290.887 271.141C290.807 271.836 290.611 272.512 290.306 273.141C287.845 278.198 278.874 278.903 270.269 274.728C261.663 270.554 256.684 263.053 259.154 257.996C261.625 252.939 270.586 252.231 279.189 256.409C284.019 258.758 287.706 262.148 289.576 265.564",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M261.86 255.326L283.793 277.252",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M259.202 258.244L278.185 277.217",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M265.937 253.831L287.979 275.865",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M285.149 267.576L290.408 272.833",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M271.513 253.945L284.257 266.684",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M279.925 256.78L289.096 265.951",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M259.018 263.618L269.98 274.576",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M185.735 258.123V266.716H183.033V271.687H171.283V266.716H158.137V258.123L169.448 240.028H183.033V258.123H185.735ZM171.258 258.123V252.241L168.543 258.123H171.258Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M212.477 242.562C213.292 243.104 214.051 243.727 214.741 244.422C216.155 245.856 217.27 247.557 218.021 249.425C219.618 253.567 219.618 258.155 218.021 262.297C217.269 264.165 216.154 265.866 214.741 267.3C213.342 268.699 211.682 269.808 209.854 270.564C205.995 272.13 201.677 272.13 197.818 270.564C195.99 269.809 194.329 268.7 192.931 267.3C191.516 265.867 190.401 264.166 189.651 262.297C188.05 258.156 188.05 253.567 189.651 249.425C191.141 245.68 194.089 242.702 197.818 241.171C199.725 240.38 201.772 239.981 203.836 239.997C204.879 239.994 205.921 240.093 206.945 240.292M203.836 250.174C202.932 250.174 202.102 250.615 201.346 251.498C200.591 252.38 200.214 253.838 200.216 255.872C200.216 257.908 200.593 259.367 201.346 260.25C202.1 261.132 202.93 261.574 203.836 261.574C204.742 261.574 205.571 261.132 206.322 260.25C207.074 259.367 207.452 257.908 207.456 255.872C207.456 253.838 207.078 252.38 206.322 251.498C205.567 250.615 204.738 250.17 203.836 250.161V250.174Z",
    fill: "#53F2D4"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M212.477 242.562C213.292 243.104 214.051 243.727 214.741 244.422C216.155 245.856 217.27 247.557 218.021 249.425C219.618 253.567 219.618 258.155 218.021 262.297C217.269 264.165 216.154 265.866 214.741 267.3C213.342 268.699 211.682 269.808 209.854 270.564C205.995 272.13 201.677 272.13 197.818 270.564C195.99 269.809 194.329 268.7 192.931 267.3C191.516 265.867 190.401 264.166 189.651 262.297C188.05 258.156 188.05 253.567 189.651 249.425C191.141 245.68 194.089 242.702 197.818 241.171C199.725 240.38 201.772 239.981 203.836 239.997C204.879 239.994 205.921 240.093 206.945 240.292M203.836 250.174C202.932 250.174 202.102 250.615 201.346 251.498C200.591 252.38 200.214 253.838 200.216 255.872C200.216 257.908 200.593 259.367 201.346 260.25C202.1 261.132 202.93 261.574 203.836 261.574C204.742 261.574 205.571 261.132 206.322 260.25C207.074 259.367 207.452 257.908 207.456 255.872C207.456 253.838 207.078 252.38 206.322 251.498C205.567 250.615 204.738 250.17 203.836 250.161V250.174Z",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M249.986 258.123V266.716H247.271V271.687H235.522V266.716H222.384V258.123L233.699 240.028H247.271V258.123H249.986ZM235.509 258.123V252.241L232.794 258.123H235.509Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M215.217 134.064C211.534 139.958 196.086 137.364 176.998 128.627C169.424 125.129 162.084 121.148 155.021 116.709C147.936 112.308 141.142 107.456 134.68 102.184C118.459 88.8575 109.356 76.11 113.039 70.2159C116.167 65.209 127.788 66.3219 142.916 72.126C143.548 78.411 153.984 87.8382 167.969 96.577C181.847 105.249 194.8 110.482 200.798 108.418C212.39 119.323 218.314 129.108 215.217 134.064Z",
    fill: "#9E59FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M202.787 107.219C202.741 107.294 202.665 107.343 202.598 107.398C202.072 107.854 201.46 108.201 200.798 108.418C194.809 110.488 181.847 105.249 167.969 96.577C153.984 87.8382 143.548 78.411 142.916 72.126C142.829 71.4068 142.899 70.6772 143.122 69.9878C143.128 69.9747 143.136 69.9623 143.145 69.9507C143.754 69.1212 144.392 68.3299 145.061 67.5766C156.465 54.566 175.682 51.2225 190.526 60.4983C205.37 69.7741 210.785 88.5086 204.076 104.485C203.697 105.392 203.26 106.307 202.787 107.219Z",
    fill: "#87D4FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M200.798 108.418C194.809 110.488 181.847 105.249 167.969 96.577C153.984 87.8382 143.548 78.411 142.916 72.126C150.082 74.9272 157.046 78.2213 163.757 81.9847C166.887 83.7079 170.045 85.5675 173.233 87.5634C176.419 89.5544 179.486 91.5809 182.408 93.6329C188.882 98.1173 195.028 103.058 200.798 108.418Z",
    fill: "#62A3FF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M205.269 116.146C202.077 121.255 183.389 115.39 163.566 103.003C143.742 90.6159 130.266 76.4215 133.476 71.2845C134.698 69.3291 138.155 68.9642 143.108 69.9791C141.058 76.1122 152.279 86.773 167.955 96.5683C183.445 106.248 197.797 111.651 202.584 107.389C205.387 111.182 206.45 114.255 205.269 116.146Z",
    fill: "#FF5986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M176.998 128.627C172.49 130.415 167.163 130.826 161.734 129.778C153.584 128.135 146.258 123.712 141.008 117.265C137.272 112.639 135.068 107.341 134.68 102.184C141.142 107.456 147.936 112.308 155.021 116.709C162.084 121.148 169.424 125.129 176.998 128.627Z",
    fill: "#1D1E5F",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M146.675 104.351C144.185 102.589 141.819 100.826 139.621 99.1033C125.702 88.2228 117.521 78.2671 120.046 74.2263C120.977 72.7353 123.253 72.194 126.583 72.4985",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M156.896 111.145C154.667 109.752 152.508 108.349 150.42 106.936",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M197.39 130.584C203.726 132.237 208.142 132.136 209.529 129.916C210.458 128.43 209.947 126.147 208.217 123.283",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M199.6 81.8101C199.831 83.0079 199.935 84.2269 199.911 85.4466",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M191.614 69.8579C194.897 72.1129 197.418 75.312 198.843 79.0316",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M173.446 70.7176L174.21 78.2798",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M176.062 72.5978L176.246 74.4631",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M171.201 72.5117L171.609 76.5512",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M190.517 60.4926L198.78 47.2692",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M197.078 49.4028C198.348 50.1963 200.021 49.8101 200.814 48.5404C201.607 47.2706 201.221 45.598 199.952 44.8046C198.682 44.0112 197.009 44.3973 196.216 45.6671C195.422 46.9368 195.809 48.6094 197.078 49.4028Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M112.515 185.001C109.478 186.756 107.143 189.51 105.908 192.794C104.034 197.861 104.816 204.02 101.37 208.19C99.2853 210.71 96.072 211.925 93.2978 213.647C92.3036 214.256 91.388 214.986 90.5717 215.818C87.9772 215.785 85.4306 215.116 83.1544 213.87C80.666 212.561 77.7282 209.666 76.042 207.424C74.4331 205.275 73.4651 202.701 71.8992 200.514C70.8479 199.068 69.549 197.819 68.0625 196.825C68.4672 196.529 68.8799 196.251 69.2961 195.988C71.6722 194.521 74.3165 193.442 76.3796 191.567C80.1494 188.149 81.3785 182.678 84.8428 178.953C89.6685 173.773 97.9604 172.864 102.526 167.438C104.898 164.625 105.971 160.891 108.341 158.07C113.251 152.207 122.536 151.518 127.337 145.561C130.869 141.18 131.152 134.918 134.314 130.261C136.909 126.439 141.155 124.119 144.828 121.28C146.38 122.679 148.051 123.94 149.823 125.047C150.121 125.233 150.418 125.419 150.711 125.602C147.099 130.772 141.443 134.852 138.727 140.646C136.837 144.703 136.501 149.375 134.411 153.339C131.236 159.299 124.305 163.022 122.504 169.543C121.506 173.207 122.193 177.492 119.847 180.482C118.076 182.747 115.026 183.547 112.515 185.001Z",
    fill: "#FF81AF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M123.113 231.386C119.165 229.074 112.762 230.382 108.511 227.396C105.968 225.607 104.441 223.213 102.94 220.86C102.476 220.132 101.936 219.455 101.329 218.84C98.9854 216.58 95.7674 215.464 92.5281 215.788C91.8717 215.844 91.2128 215.863 90.5542 215.846C91.3706 215.013 92.2861 214.284 93.2803 213.675C96.0546 211.953 99.2678 210.738 101.353 208.218C104.798 204.048 104.011 197.886 105.891 192.822C107.124 189.525 109.466 186.76 112.515 185.001C115.039 183.555 118.09 182.756 119.87 180.465C122.217 177.475 121.516 173.181 122.528 169.525C124.329 163.004 131.26 159.282 134.435 153.322C136.543 149.369 136.87 144.691 138.75 140.628C141.453 134.826 147.109 130.746 150.734 125.584C152.91 126.868 155.217 127.916 157.616 128.709C156.505 130.373 155.237 131.927 153.831 133.351C151.291 135.968 149.079 139.055 148.724 142.682C148.538 144.665 148.788 146.713 148.284 148.646C147.031 153.411 141.454 156.694 141.746 161.61C141.856 163.326 142.705 164.954 142.695 166.666C142.675 170.832 137.993 173.228 135.913 176.836C133.561 180.921 134.793 186.018 135.913 190.593C137.033 195.167 137.818 200.495 134.879 204.154C133.578 205.77 131.707 206.822 130.158 208.205C127.166 210.906 125.466 214.753 125.486 218.783C125.515 221.01 126.07 223.243 125.807 225.442C125.452 227.628 124.523 229.679 123.113 231.386Z",
    fill: "#6DE4A2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M124.842 198.038C124.646 200.305 124.035 202.532 122.281 203.871C121.257 204.652 119.973 205.012 118.845 205.599C117.759 206.186 116.811 206.999 116.064 207.981",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M125.415 190.433C125.067 191.864 124.904 193.333 124.93 194.806",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M127.329 145.543C122.528 151.5 113.243 152.189 108.333 158.052C105.968 160.876 104.885 164.604 102.518 167.42C97.9522 172.846 89.6603 173.755 84.8346 178.935C81.3703 182.66 80.1412 188.131 76.3714 191.549C74.3083 193.424 71.664 194.503 69.2879 195.97C68.8717 196.233 68.4589 196.511 68.0543 196.807C66.6361 195.863 65.0706 195.162 63.4219 194.733C61.7011 194.304 59.9124 194.148 58.2363 193.585C52.1897 191.531 50.0194 188.741 47.5047 186.078C48.0483 181.478 53.1806 177.419 61.9211 174.821C71.7989 171.881 69.2736 161.235 78.2903 156.304C85.6902 152.254 97.3839 154.924 102.544 148.558C104.476 146.168 104.891 142.921 106.27 140.166C114.319 124.122 129.554 129.599 140.987 117.298C142.146 118.736 143.421 120.077 144.798 121.307C141.125 124.146 136.88 126.466 134.284 130.288C131.138 134.91 130.859 141.174 127.329 145.543Z",
    fill: "#FFE483",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M123.837 133.861C120.691 134.529 117.968 136.483 116.329 139.251C115.075 141.392 114.322 144.158 112.054 145.162",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4535 181.127C68.057 180.877 69.7801 181.075 71.2168 180.326C72.9096 179.446 73.7153 177.495 74.5703 175.776C75.4252 174.056 76.7644 172.264 78.6535 172.114",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2234 185.63C61.0142 184.084 62.2575 182.815 63.7876 181.993",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M139.47 244.597C135.406 242.917 130.036 242.28 125.51 233.866C124.955 232.822 124.117 231.956 123.093 231.367C124.492 229.672 125.418 227.637 125.777 225.469C126.052 223.251 125.497 221.019 125.456 218.81C125.437 214.78 127.136 210.932 130.129 208.232C131.677 206.849 133.549 205.797 134.849 204.181C137.792 200.505 137.003 195.194 135.884 190.619C134.764 186.045 133.531 180.948 135.883 176.863C137.964 173.255 142.641 170.856 142.665 166.693C142.675 164.981 141.826 163.353 141.717 161.637C141.424 156.721 147.002 153.438 148.255 148.673C148.758 146.74 148.508 144.691 148.694 142.709C149.042 139.051 151.262 135.995 153.802 133.378C155.203 131.951 156.466 130.394 157.573 128.727C158.926 129.181 160.308 129.542 161.71 129.807C155.934 143.577 165.612 153.132 160.171 165.012C158.896 167.806 151.706 176.76 150.413 179.542C146.95 186.975 154.473 196.32 154.081 204.741C153.601 215.007 142.595 216.455 142.374 226.753C142.285 231.412 143.502 240.833 139.47 244.597Z",
    fill: "#C0FF97",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M156.216 154.339C156.487 155.593 156.288 156.903 155.659 158.021C154.892 159.517 153.755 160.861 153.374 162.495",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M136.105 219.329C137.336 222.032 137.266 225.149 135.917 227.794C135.185 229.203 134.113 230.413 133.398 231.826C132.682 233.239 132.357 235.051 133.208 236.377",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1514 204.6C32.685 203.026 33.2339 201.328 34.533 200.324C33.2971 199.188 32.9079 197.398 33.5606 195.852C34.2133 194.305 35.7672 193.335 37.4434 193.428C39.1195 193.521 40.5566 194.657 41.0343 196.266C41.106 196.513 41.1552 196.765 41.1814 197.021L41.3166 196.979C42.9925 196.541 44.7594 197.238 45.6843 198.703C46.6093 200.167 46.4793 202.062 45.363 203.387C44.2467 204.712 42.4012 205.161 40.8009 204.498C40.3393 206.215 38.7931 207.417 37.0148 207.441C35.2365 207.465 33.6587 206.305 33.1514 204.6Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0155 204.578C40.4236 204.36 39.8937 204.001 39.4714 203.532L41.0155 204.578Z",
    fill: "#FFE2BF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0155 204.578C40.4236 204.36 39.8937 204.001 39.4714 203.532",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0038 197.65C40.385 197.339 40.8285 197.112 41.3045 196.986L40.0038 197.65Z",
    fill: "#FFE2BF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0038 197.65C40.385 197.339 40.8285 197.112 41.3045 196.986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8934 200.941C34.3979 200.331 35.0721 199.884 35.8306 199.658C36.0464 199.594 36.2671 199.547 36.4905 199.519",
    fill: "#FFE2BF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8934 200.941C34.3979 200.331 35.0721 199.884 35.8306 199.658C36.0464 199.594 36.2671 199.547 36.4905 199.519",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M60.307 181.62C58.6656 181.637 57.1826 180.643 56.5738 179.119C55.1416 179.996 53.3123 179.879 52.0038 178.826C50.6953 177.773 50.1901 176.01 50.7416 174.424C51.2931 172.837 52.7823 171.768 54.462 171.754C54.7189 171.751 54.9755 171.773 55.2281 171.82L55.2258 171.676C55.2652 169.945 56.4216 168.438 58.0841 167.951C59.7467 167.465 61.5328 168.111 62.4993 169.549C63.4658 170.987 63.3902 172.884 62.3124 174.241C63.8403 175.156 64.573 176.976 64.1055 178.694C63.638 180.413 62.0844 181.611 60.3033 181.626L60.307 181.62Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4556 174.052C62.0819 174.561 61.5907 174.971 61.024 175.249L62.4556 174.052Z",
    fill: "#FFE2BF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4556 174.052C62.0819 174.561 61.5907 174.971 61.024 175.249",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5142 173.118C55.3209 172.661 55.2266 172.167 55.2378 171.67L55.5142 173.118Z",
    fill: "#FFE2BF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5142 173.118C55.3209 172.661 55.2266 172.167 55.2378 171.67",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9971 179.897C56.5473 179.248 56.3017 178.479 56.2916 177.689C56.2905 177.465 56.3073 177.242 56.342 177.022",
    fill: "#FFE2BF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9971 179.897C56.5473 179.248 56.3017 178.479 56.2916 177.689C56.2905 177.465 56.3073 177.242 56.342 177.022",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3927 193.195C51.1276 194.242 49.3492 194.402 47.9176 193.598C47.3565 195.18 45.862 196.239 44.1833 196.245C42.5046 196.25 41.0035 195.2 40.4324 193.622C39.8614 192.043 40.3435 190.276 41.6371 189.206C41.8342 189.041 42.0482 188.898 42.2754 188.779C42.245 188.74 42.2127 188.705 42.184 188.663C41.121 187.293 41.0688 185.392 42.055 183.965C43.0411 182.539 44.8382 181.916 46.4955 182.427C48.1528 182.938 49.2878 184.464 49.3003 186.198C51.0615 185.949 52.7736 186.9 53.4926 188.527C54.2116 190.154 53.7624 192.06 52.3927 193.195Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2898 185.967C49.3221 186.598 49.2002 187.227 48.9348 187.799L49.2898 185.967Z",
    fill: "#FFE2BF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2898 185.967C49.3221 186.598 49.2002 187.227 48.9348 187.799",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3166 189.61C42.8794 189.384 42.4964 189.065 42.1936 188.677L43.3166 189.61Z",
    fill: "#FFE2BF"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3166 189.61C42.8794 189.384 42.4964 189.065 42.1936 188.677",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M48.736 193.944C47.9754 193.722 47.2991 193.276 46.7946 192.665C46.6491 192.49 46.5185 192.304 46.4043 192.107",
    fill: "#FFE2BF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M48.736 193.944C47.9754 193.722 47.2991 193.276 46.7946 192.665C46.6491 192.49 46.5185 192.304 46.4043 192.107",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3636 178.073C75.9238 177.285 75.1156 175.693 75.3287 174.066C73.6504 174.135 72.1094 173.143 71.479 171.585C70.8487 170.028 71.265 168.243 72.5192 167.126C73.7733 166.008 75.5945 165.799 77.0689 166.604C77.2904 166.727 77.5004 166.87 77.6964 167.03L77.7659 166.904C78.4719 165.653 79.7986 164.879 81.2357 164.882C82.6728 164.885 83.9967 165.663 84.6982 166.917C85.3997 168.171 85.3697 169.706 84.6196 170.932C84.1815 171.683 83.5071 172.267 82.7019 172.593C83.5905 174.136 83.3449 176.082 82.1006 177.355C80.8564 178.629 78.917 178.92 77.3537 178.067L77.3636 178.073Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.3637 178.073C75.9238 177.285 75.1157 175.693 75.3288 174.066C73.6504 174.135 72.1094 173.142 71.4791 171.585C70.8487 170.028 71.2651 168.243 72.5192 167.126C73.7734 166.008 75.5946 165.799 77.069 166.604C77.2904 166.727 77.5004 166.869 77.6964 167.03L77.766 166.904C78.472 165.653 79.7986 164.879 81.2358 164.882C82.6729 164.884 83.9967 165.662 84.6983 166.917C85.3998 168.171 85.3697 169.706 84.6197 170.932C84.1816 171.682 83.5072 172.267 82.702 172.593C83.5906 174.136 83.3449 176.081 82.1007 177.355C80.8564 178.629 78.917 178.92 77.3538 178.067L77.3637 178.073Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9218 172.508C82.3476 172.769 81.7188 172.889 81.0887 172.856L82.9218 172.508Z",
    fill: "#FFE2BF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9218 172.508C82.3476 172.769 81.7188 172.889 81.0887 172.856",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3173 168.313C77.366 167.823 77.5199 167.349 77.7685 166.923L77.3173 168.313Z",
    fill: "#FFE2BF"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3173 168.313C77.366 167.823 77.5199 167.349 77.7685 166.923",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3113 174.954C75.2138 173.937 75.5138 172.921 76.1483 172.12L75.3113 174.954Z",
    fill: "#FFE2BF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3113 174.954C75.2138 173.937 75.5138 172.921 76.1483 172.12",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8932 176.933C71.6241 177.98 69.8416 178.138 68.4082 177.33C68.1699 178.009 67.7492 178.609 67.1921 179.065C65.4961 180.403 63.0417 180.142 61.6652 178.477C60.2887 176.812 60.4941 174.352 62.1277 172.938C62.3269 172.775 62.5413 172.63 62.7679 172.507C62.7283 172.486 62.7051 172.434 62.6747 172.395C61.6134 171.025 61.5619 169.126 62.5475 167.7C63.5332 166.274 65.3287 165.652 66.9853 166.161C68.6419 166.67 69.7778 168.194 69.7928 169.927C71.5553 169.676 73.2693 170.628 73.9883 172.257C74.7073 173.886 74.2558 175.794 72.8833 176.928L72.8932 176.933Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7955 169.704C69.8248 170.334 69.7018 170.961 69.4371 171.534L69.7955 169.704Z",
    fill: "#FFE2BF"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7955 169.704C69.8248 170.334 69.7018 170.961 69.4371 171.534",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8171 173.348C63.3799 173.121 62.9974 172.801 62.696 172.411L63.8171 173.348Z",
    fill: "#FFE2BF"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8171 173.348C63.3799 173.121 62.9974 172.801 62.696 172.411",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2366 177.682C68.4763 177.458 67.8007 177.011 67.297 176.399C67.1546 176.227 67.0267 176.044 66.9147 175.851",
    fill: "#FFE2BF"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2366 177.682C68.4763 177.458 67.8007 177.011 67.297 176.399C67.1546 176.227 67.0267 176.044 66.9147 175.851",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5508 172.928C94.2415 174.54 92.9727 175.795 91.3577 176.087C91.606 176.763 91.6638 177.494 91.5248 178.2C91.2993 179.634 90.3099 180.832 88.9439 181.323C87.5778 181.815 86.0524 181.523 84.9647 180.561C83.8769 179.6 83.3998 178.122 83.7201 176.706C83.7703 176.452 83.8443 176.204 83.9409 175.965L83.8 175.938C81.7565 175.37 80.5195 173.297 80.9894 171.228C81.4592 169.16 83.4703 167.824 85.559 168.194C86.4071 168.381 87.1691 168.844 87.7252 169.511C88.9243 168.196 90.8513 167.838 92.4426 168.635C94.0338 169.432 94.9018 171.189 94.5673 172.937L94.5508 172.928Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.5508 172.928C94.2415 174.54 92.9727 175.795 91.3577 176.087C91.606 176.763 91.6638 177.494 91.5248 178.2C91.2993 179.634 90.3099 180.832 88.9439 181.323C87.5778 181.815 86.0524 181.523 84.9647 180.561C83.8769 179.6 83.3998 178.122 83.7201 176.706C83.7703 176.452 83.8443 176.204 83.9409 175.965L83.8 175.938C81.7565 175.37 80.5195 173.297 80.9894 171.228C81.4592 169.16 83.4703 167.824 85.559 168.194C86.4071 168.381 87.1691 168.844 87.7252 169.511C88.9243 168.196 90.8513 167.838 92.4426 168.635C94.0338 169.432 94.9018 171.189 94.5673 172.937L94.5508 172.928Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5571 169.332C87.9817 169.798 88.2876 170.36 88.449 170.97L87.5571 169.332Z",
    fill: "#FFE2BF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5571 169.332C87.9817 169.798 88.2876 170.36 88.449 170.97",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2683 175.945C84.7871 176.05 84.2888 176.047 83.8085 175.939L85.2683 175.945Z",
    fill: "#FFE2BF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2683 175.945C84.7871 176.05 84.2888 176.047 83.8085 175.939",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M92.21 175.835C91.4856 176.145 90.6857 176.233 89.9111 176.088C89.6918 176.048 89.4766 175.988 89.2681 175.909",
    fill: "#FFE2BF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M92.21 175.835C91.4856 176.145 90.6857 176.233 89.9111 176.088C89.6918 176.048 89.4766 175.988 89.2681 175.909",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8612 214.902C45.4969 215.816 43.7119 215.799 42.3644 214.861C41.6486 216.382 40.0535 217.288 38.3806 217.125C36.7076 216.961 35.3183 215.763 34.9106 214.132C34.503 212.501 35.1651 210.79 36.5644 209.859C36.7782 209.717 37.0046 209.596 37.2406 209.496C37.2121 209.456 37.1857 209.416 37.1613 209.374C36.242 207.904 36.3808 206.009 37.5043 204.689C38.6278 203.369 40.477 202.929 42.0745 203.602C43.6719 204.274 44.6494 205.905 44.4902 207.631C46.2694 207.557 47.8807 208.675 48.4339 210.368C48.9871 212.06 48.3472 213.914 46.8678 214.905L46.8612 214.902Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4929 207.408C44.4547 208.036 44.2647 208.646 43.9391 209.186L44.4929 207.408Z",
    fill: "#FFE2BF"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4929 207.408C44.4547 208.036 44.2647 208.646 43.9391 209.186",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1879 210.427C37.7741 210.16 37.424 209.805 37.1624 209.388L38.1879 210.427Z",
    fill: "#FFE2BF"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1879 210.427C37.7741 210.16 37.424 209.805 37.1624 209.388",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1404 215.291C42.406 214.994 41.7778 214.484 41.3371 213.825C41.2136 213.639 41.1055 213.444 41.0139 213.24",
    fill: "#FFE2BF"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1404 215.291C42.406 214.994 41.7778 214.484 41.3371 213.825C41.2136 213.639 41.1055 213.444 41.0139 213.24",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9096 198.126C52.6003 199.738 51.3314 200.994 49.7165 201.286C50.2949 202.864 49.819 204.634 48.5278 205.71C47.2365 206.785 45.4087 206.932 43.962 206.077C42.5153 205.223 41.7622 203.551 42.0807 201.901C42.1276 201.646 42.2004 201.398 42.2982 201.158L42.1573 201.132C40.4664 200.752 39.2165 199.32 39.068 197.594C38.9196 195.867 39.9068 194.243 41.5081 193.58C43.1093 192.917 44.9556 193.368 46.0712 194.694C47.2709 193.38 49.1979 193.023 50.7887 193.821C52.3795 194.618 53.2466 196.375 52.9114 198.123L52.9096 198.126Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9096 198.126C52.6003 199.738 51.3314 200.994 49.7165 201.286C50.2949 202.864 49.819 204.634 48.5278 205.71C47.2365 206.785 45.4087 206.932 43.962 206.077C42.5153 205.223 41.7622 203.551 42.0807 201.901C42.1276 201.646 42.2004 201.398 42.2982 201.158L42.1573 201.132C40.4664 200.752 39.2165 199.32 39.068 197.594C38.9196 195.867 39.9068 194.243 41.5081 193.58C43.1093 192.917 44.9556 193.368 46.0712 194.694C47.2709 193.38 49.1979 193.023 50.7887 193.821C52.3795 194.618 53.2466 196.375 52.9114 198.123L52.9096 198.126Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9244 194.531C46.3463 194.999 46.6487 195.562 46.806 196.172L45.9244 194.531Z",
    fill: "#FFE2BF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9244 194.531C46.3463 194.999 46.6487 195.562 46.806 196.172",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6322 201.142C43.1505 201.247 42.6518 201.246 42.1705 201.139L43.6322 201.142Z",
    fill: "#FFE2BF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6322 201.142C43.1505 201.247 42.6518 201.246 42.1705 201.139",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5689 201.033C49.8445 201.343 49.0445 201.431 48.2699 201.287C48.051 201.245 47.836 201.185 47.627 201.108",
    fill: "#FFE2BF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5689 201.033C49.8445 201.343 49.0445 201.431 48.2699 201.287C48.051 201.245 47.836 201.185 47.627 201.108",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9133 188.632C68.5322 189.52 66.7468 189.466 65.4223 188.495C65.1042 189.141 64.6151 189.686 64.0083 190.073C62.735 190.888 61.1094 190.91 59.8142 190.13C58.5189 189.35 57.7782 187.903 57.903 186.396C58.0278 184.89 58.9966 183.584 60.4025 183.028C60.3733 182.989 60.3468 182.949 60.3232 182.906C59.4315 181.419 59.6069 179.525 60.7566 178.227C61.9064 176.928 63.7651 176.525 65.3495 177.23C66.9338 177.936 67.8782 179.586 67.683 181.31C69.4642 181.271 71.0537 182.422 71.5728 184.126C72.0919 185.83 71.4137 187.672 69.9133 188.632Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.9133 188.632C68.5322 189.52 66.7468 189.466 65.4223 188.495C65.1042 189.141 64.6151 189.686 64.0083 190.073C62.735 190.888 61.1094 190.91 59.8142 190.13C58.5189 189.35 57.7782 187.903 57.903 186.396C58.0278 184.89 58.9966 183.584 60.4025 183.028C60.3733 182.989 60.3468 182.949 60.3232 182.906C59.4315 181.419 59.6069 179.525 60.7566 178.227C61.9064 176.928 63.7651 176.525 65.3495 177.23C66.9338 177.936 67.8782 179.586 67.683 181.31C69.4642 181.271 71.0537 182.422 71.5728 184.126C72.0919 185.83 71.4137 187.672 69.9133 188.632Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6979 181.08C67.6589 181.712 67.4676 182.324 67.1404 182.865L67.6979 181.08Z",
    fill: "#FFE2BF"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6979 181.08C67.6589 181.712 67.4676 182.324 67.1404 182.865",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3271 183.976C60.9199 183.701 60.5782 183.339 60.3261 182.917L61.3271 183.976Z",
    fill: "#FFE2BF"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3271 183.976C60.9199 183.701 60.5782 183.339 60.3261 182.917",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1861 188.932C65.4639 188.618 64.8514 188.097 64.4264 187.434C64.307 187.242 64.2037 187.04 64.1174 186.831",
    fill: "#FFE2BF"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1861 188.932C65.4639 188.618 64.8514 188.097 64.4264 187.434C64.307 187.242 64.2037 187.04 64.1174 186.831",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3068 226.22C47.911 227.084 46.1272 226.998 44.8209 226.004C44.0491 227.495 42.4237 228.341 40.7596 228.117C39.0956 227.892 37.7518 226.647 37.402 225.005C37.0523 223.363 37.772 221.678 39.2004 220.795C39.4184 220.658 39.6504 220.545 39.8924 220.458C39.867 220.418 39.8435 220.374 39.8149 220.333C38.8437 218.443 39.5302 216.123 41.3734 215.067C43.2167 214.01 45.5652 214.589 46.7053 216.382C47.1414 217.134 47.3152 218.009 47.1994 218.871C48.9781 218.862 50.5453 220.038 51.0356 221.747C51.5259 223.457 50.8196 225.284 49.3068 226.22Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3068 226.22C47.911 227.084 46.1272 226.998 44.8209 226.004C44.0491 227.495 42.4237 228.341 40.7596 228.117C39.0956 227.892 37.7518 226.647 37.402 225.005C37.0523 223.363 37.772 221.678 39.2004 220.795C39.4184 220.658 39.6504 220.545 39.8924 220.458C39.867 220.418 39.8435 220.374 39.8149 220.333C38.8437 218.443 39.5302 216.123 41.3734 215.067C43.2167 214.01 45.5652 214.589 46.7053 216.382C47.1414 217.134 47.3152 218.009 47.1994 218.871C48.9781 218.862 50.5453 220.038 51.0356 221.747C51.5259 223.457 50.8196 225.284 49.3068 226.22Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2362 218.641C47.1803 219.269 46.9737 219.874 46.634 220.405L47.2362 218.641Z",
    fill: "#FFE2BF"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2362 218.641C47.1803 219.269 46.9737 219.874 46.634 220.405",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8111 221.424C40.4042 221.144 40.0633 220.778 39.8123 220.353L40.8111 221.424Z",
    fill: "#FFE2BF"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8111 221.424C40.4042 221.144 40.0633 220.778 39.8123 220.353",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5821 226.46C44.8621 226.135 44.2557 225.602 43.8407 224.93C43.7228 224.739 43.6216 224.539 43.5384 224.33",
    fill: "#FFE2BF"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5821 226.46C44.8621 226.135 44.2557 225.602 43.8407 224.93C43.7228 224.739 43.6216 224.539 43.5384 224.33",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5901 193.698C62.2808 195.311 61.0113 196.568 59.3952 196.861C59.6445 197.536 59.7041 198.266 59.5674 198.972C59.3419 200.406 58.3525 201.604 56.9864 202.095C55.6204 202.587 54.095 202.295 53.0073 201.333C51.9195 200.372 51.4424 198.894 51.7627 197.478C51.81 197.223 51.8829 196.975 51.9802 196.735L51.8393 196.709C50.1484 196.329 48.8985 194.897 48.75 193.17C48.6016 191.444 49.5888 189.82 51.1901 189.157C52.7913 188.494 54.6376 188.945 55.7532 190.271C56.9535 188.961 58.8775 188.606 60.466 189.402C62.0545 190.199 62.9217 191.952 62.5901 193.698Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5901 193.698C62.2808 195.311 61.0113 196.568 59.3952 196.861C59.6445 197.536 59.7041 198.266 59.5674 198.972C59.3419 200.406 58.3525 201.604 56.9864 202.095C55.6204 202.587 54.095 202.295 53.0073 201.333C51.9195 200.372 51.4424 198.894 51.7627 197.478C51.81 197.223 51.8829 196.975 51.9802 196.735L51.8393 196.709C50.1484 196.329 48.8985 194.897 48.75 193.17C48.6016 191.444 49.5888 189.82 51.1901 189.157C52.7913 188.494 54.6376 188.945 55.7532 190.271C56.9535 188.961 58.8775 188.606 60.466 189.402C62.0545 190.199 62.9217 191.952 62.5901 193.698Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6037 190.089C56.0299 190.555 56.3355 191.119 56.4938 191.73L55.6037 190.089Z",
    fill: "#FFE2BF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6037 190.089C56.0299 190.555 56.3355 191.119 56.4938 191.73",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3182 196.704C52.8363 196.807 52.338 196.806 51.8566 196.701L53.3182 196.704Z",
    fill: "#FFE2BF"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3182 196.704C52.8363 196.807 52.338 196.806 51.8566 196.701",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2549 196.595C59.5305 196.905 58.7305 196.993 57.956 196.849C57.7375 196.805 57.5226 196.745 57.313 196.669",
    fill: "#FFE2BF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2549 196.595C59.5305 196.905 58.7305 196.993 57.956 196.849C57.7375 196.805 57.5226 196.745 57.313 196.669",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M103.561 177.676C103.248 179.287 101.979 180.541 100.364 180.834C100.943 182.411 100.467 184.182 99.1755 185.257C97.8842 186.332 96.0564 186.48 94.6097 185.625C93.163 184.77 92.4099 183.098 92.7284 181.449C92.7746 181.194 92.8486 180.946 92.9492 180.708C92.9005 180.702 92.8523 180.692 92.805 180.68C91.1122 180.302 89.8596 178.87 89.7102 177.142C89.5608 175.414 90.5491 173.788 92.152 173.126C93.7549 172.463 95.6025 172.916 96.717 174.245C97.9156 172.926 99.8455 172.566 101.439 173.364C103.033 174.162 103.9 175.923 103.562 177.673L103.561 177.676Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5654 174.075C96.9904 174.542 97.2958 175.105 97.4555 175.716L96.5654 174.075Z",
    fill: "#FFE2BF"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5654 174.075C96.9904 174.542 97.2958 175.105 97.4555 175.716",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2781 180.693C93.7966 180.795 93.2988 180.793 92.8182 180.687L94.2781 180.693Z",
    fill: "#FFE2BF"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2781 180.693C93.7966 180.795 93.2988 180.793 92.8182 180.687",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M101.218 180.578C100.494 180.889 99.6939 180.978 98.9194 180.831C98.6994 180.789 98.4832 180.728 98.2731 180.65",
    fill: "#FFE2BF"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M101.218 180.578C100.494 180.889 99.6939 180.978 98.9194 180.831C98.6994 180.789 98.4832 180.728 98.2731 180.65",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7138 201.452C63.4034 203.064 62.1344 204.321 60.5189 204.615C60.7687 205.289 60.8271 206.019 60.6877 206.724C60.4622 208.158 59.4728 209.356 58.1068 209.847C56.7408 210.339 55.2154 210.047 54.1276 209.085C53.0399 208.124 52.5628 206.646 52.8831 205.23C52.9333 204.976 53.0072 204.728 53.1038 204.489L52.963 204.462C51.2721 204.083 50.0221 202.651 49.8737 200.924C49.7253 199.198 50.7125 197.574 52.3138 196.911C53.915 196.248 55.7612 196.698 56.8768 198.025C58.0759 196.71 60.0028 196.352 61.5941 197.149C63.1854 197.945 64.0533 199.703 63.7189 201.45L63.7138 201.452Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M56.72 197.856C57.1446 198.322 57.4505 198.884 57.6119 199.494L56.72 197.856Z",
    fill: "#FFE2BF"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M56.72 197.856C57.1446 198.322 57.4505 198.884 57.6119 199.494",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4312 204.469C53.9511 204.573 53.4542 204.571 52.9747 204.465L54.4312 204.469Z",
    fill: "#FFE2BF"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4312 204.469C53.9511 204.573 53.4542 204.571 52.9747 204.465",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3731 204.359C60.6495 204.672 59.8486 204.76 59.0741 204.612C58.8548 204.572 58.6396 204.512 58.4312 204.433",
    fill: "#FFE2BF"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3731 204.359C60.6495 204.672 59.8486 204.76 59.0741 204.612C58.8548 204.572 58.6396 204.512 58.4312 204.433",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4339 184.936C94.1236 186.549 92.8546 187.805 91.239 188.099C91.4888 188.773 91.5473 189.503 91.4079 190.209C91.1824 191.643 90.193 192.84 88.827 193.332C87.4609 193.823 85.9355 193.531 84.8478 192.57C83.76 191.608 83.2829 190.13 83.6032 188.714C83.6534 188.461 83.7274 188.213 83.824 187.973L83.6831 187.947C81.9922 187.567 80.7423 186.136 80.5939 184.409C80.4454 182.682 81.4327 181.058 83.0339 180.395C84.6352 179.732 86.4814 180.183 87.597 181.509C88.7961 180.194 90.723 179.836 92.3143 180.633C93.9056 181.43 94.7735 183.187 94.4391 184.935L94.4339 184.936Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.4339 184.936C94.1236 186.549 92.8546 187.805 91.239 188.099C91.4888 188.773 91.5473 189.503 91.4079 190.209C91.1824 191.643 90.193 192.84 88.827 193.332C87.4609 193.823 85.9355 193.531 84.8478 192.57C83.76 191.608 83.2829 190.13 83.6032 188.714C83.6534 188.461 83.7274 188.213 83.824 187.973L83.6831 187.947C81.9922 187.567 80.7423 186.136 80.5939 184.409C80.4454 182.682 81.4327 181.058 83.0339 180.395C84.6352 179.732 86.4814 180.183 87.597 181.509C88.7961 180.194 90.723 179.836 92.3143 180.633C93.9056 181.43 94.7735 183.187 94.4391 184.935L94.4339 184.936Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4402 181.34C87.8648 181.807 88.1707 182.369 88.3321 182.979L87.4402 181.34Z",
    fill: "#FFE2BF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4402 181.34C87.8648 181.807 88.1707 182.369 88.3321 182.979",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1514 187.954C84.6713 188.057 84.1744 188.056 83.6949 187.949L85.1514 187.954Z",
    fill: "#FFE2BF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1514 187.954C84.6713 188.057 84.1744 188.056 83.6949 187.949",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0932 187.843C91.3696 188.156 90.5687 188.245 89.7942 188.097C89.5749 188.057 89.3597 187.997 89.1512 187.918",
    fill: "#FFE2BF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0932 187.843C91.3696 188.156 90.5687 188.245 89.7942 188.097C89.5749 188.057 89.3597 187.997 89.1512 187.918",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2582 210.009C68.999 211.062 67.2221 211.233 65.7853 210.439C65.2331 212.025 63.7444 213.092 62.0655 213.107C60.3866 213.121 58.8796 212.08 58.3 210.504C57.7205 208.928 58.1932 207.158 59.4814 206.081C59.6794 205.917 59.8927 205.772 60.1183 205.649C60.0787 205.627 60.0555 205.575 60.025 205.537C58.9447 204.175 58.8742 202.27 59.8509 200.832C60.8276 199.394 62.6251 198.758 64.2889 199.26C65.9528 199.763 67.0972 201.288 67.1145 203.026C68.8756 202.762 70.5974 203.702 71.3271 205.327C72.0567 206.951 71.6158 208.863 70.2483 210.004L70.2582 210.009Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2582 210.009C68.999 211.062 67.2221 211.233 65.7853 210.439C65.2331 212.025 63.7444 213.092 62.0655 213.107C60.3866 213.121 58.8796 212.08 58.3 210.504C57.7205 208.928 58.1932 207.158 59.4814 206.081C59.6794 205.917 59.8927 205.772 60.1183 205.649C60.0787 205.627 60.0555 205.575 60.025 205.537C58.9447 204.175 58.8742 202.27 59.8509 200.832C60.8276 199.394 62.6251 198.758 64.2889 199.26C65.9528 199.763 67.0972 201.288 67.1145 203.026C68.8756 202.762 70.5974 203.702 71.3271 205.327C72.0567 206.951 71.6158 208.863 70.2483 210.004L70.2582 210.009Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1139 202.801C67.1478 203.431 67.0289 204.06 66.7673 204.634L67.1139 202.801Z",
    fill: "#FFE2BF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1139 202.801C67.1478 203.431 67.0289 204.06 66.7673 204.634",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1594 206.481C60.7226 206.255 60.3386 205.939 60.0328 205.554L61.1594 206.481Z",
    fill: "#FFE2BF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1594 206.481C60.7226 206.255 60.3386 205.939 60.0328 205.554",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6055 210.782C65.8448 210.561 65.167 210.12 64.6586 209.512C64.517 209.341 64.3886 209.158 64.2746 208.967",
    fill: "#FFE2BF"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6055 210.782C65.8448 210.561 65.167 210.12 64.6586 209.512C64.517 209.341 64.3886 209.158 64.2746 208.967",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5257 201.397C75.2664 202.45 73.4895 202.621 72.0528 201.827C71.8183 202.506 71.4023 203.109 70.8498 203.569C69.7637 204.505 68.2573 204.784 66.9077 204.299C65.5581 203.813 64.5748 202.638 64.3343 201.225C64.0939 199.811 64.6337 198.377 65.747 197.472C65.9429 197.306 66.1552 197.161 66.3806 197.038C66.3487 197.003 66.3187 196.966 66.2906 196.928C65.3694 195.814 65.1253 194.288 65.6531 192.942C66.1809 191.597 67.3974 190.644 68.8302 190.453C70.2631 190.263 71.6863 190.865 72.5473 192.026C73.0807 192.707 73.3748 193.545 73.3838 194.411C75.1455 194.148 76.8669 195.089 77.5965 196.714C78.3261 198.339 77.8858 200.251 76.519 201.393L76.5257 201.397Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3814 194.189C73.4153 194.819 73.2963 195.448 73.0348 196.021L73.3814 194.189Z",
    fill: "#FFE2BF"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3814 194.189C73.4153 194.819 73.2963 195.448 73.0348 196.021",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4287 197.865C66.9893 197.642 66.6033 197.326 66.2969 196.94L67.4287 197.865Z",
    fill: "#FFE2BF"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4287 197.865C66.9893 197.642 66.6033 197.326 66.2969 196.94",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M72.873 202.169C72.1123 201.949 71.4345 201.507 70.9261 200.9C70.7826 200.728 70.6537 200.544 70.5406 200.35",
    fill: "#FFE2BF"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M72.873 202.169C72.1123 201.949 71.4345 201.507 70.9261 200.9C70.7826 200.728 70.6537 200.544 70.5406 200.35",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4978 216.754C59.2387 217.806 57.4622 217.976 56.0268 217.181C55.4746 218.766 53.9858 219.834 52.307 219.849C50.6281 219.863 49.1211 218.821 48.5415 217.246C47.9619 215.67 48.4347 213.9 49.7228 212.823C49.9209 212.659 50.1341 212.514 50.3597 212.391C50.3201 212.369 50.2951 212.32 50.2646 212.282C49.195 210.918 49.1321 209.019 50.1091 207.587C51.0861 206.156 52.8779 205.522 54.5376 206.021C56.1972 206.52 57.3423 208.037 57.3677 209.77C59.1292 209.509 60.8491 210.452 61.5774 212.077C62.3057 213.702 61.8646 215.613 60.4978 216.754Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3554 209.543C57.3893 210.173 57.2703 210.802 57.0088 211.376L57.3554 209.543Z",
    fill: "#FFE2BF"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3554 209.543C57.3893 210.173 57.2703 210.802 57.0088 211.376",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4009 213.222C50.9622 212.997 50.5769 212.681 50.2709 212.294L51.4009 213.222Z",
    fill: "#FFE2BF"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4009 213.222C50.9622 212.997 50.5769 212.681 50.2709 212.294",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M56.847 217.523C56.0855 217.305 55.4073 216.863 54.9001 216.254C54.7581 216.081 54.6287 215.898 54.5127 215.707",
    fill: "#FFE2BF"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M56.847 217.523C56.0855 217.305 55.4073 216.863 54.9001 216.254C54.7581 216.081 54.6287 215.898 54.5127 215.707",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9901 190.207C80.9666 191.491 79.2587 192.013 77.6926 191.52C77.5992 192.234 77.3115 192.91 76.861 193.472C75.9919 194.629 74.5623 195.223 73.1289 195.022C71.6954 194.821 70.4847 193.856 69.9681 192.504C69.4515 191.152 69.7107 189.626 70.6448 188.52C70.8049 188.313 70.9863 188.125 71.1859 187.956L71.0714 187.867C69.7567 186.742 69.3209 184.895 69.9938 183.301C70.6667 181.707 72.2937 180.731 74.017 180.888C75.7404 181.045 77.1643 182.298 77.538 183.988C79.2108 183.388 81.0787 183.971 82.1132 185.416C83.1477 186.861 83.0975 188.817 81.9901 190.207Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4579 183.767C77.6176 184.378 77.6269 185.018 77.485 185.634L77.4579 183.767Z",
    fill: "#FFE2BF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4579 183.767C77.6176 184.378 77.6269 185.018 77.485 185.634",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3599 188.564C71.8857 188.43 71.4456 188.197 71.0692 187.879L72.3599 188.564Z",
    fill: "#FFE2BF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3599 188.564C71.8857 188.43 71.4456 188.197 71.0692 187.879",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5541 191.687C77.7647 191.626 77.0122 191.327 76.3953 190.831C76.2188 190.694 76.0551 190.541 75.9061 190.374",
    fill: "#FFE2BF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5541 191.687C77.7647 191.626 77.0122 191.327 76.3953 190.831C76.2188 190.694 76.0551 190.541 75.9061 190.374",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2281 197.248C84.9689 198.301 83.1924 198.47 81.757 197.675C81.2048 199.261 79.716 200.328 78.0372 200.343C76.3583 200.357 74.8513 199.316 74.2717 197.74C73.6921 196.164 74.1649 194.394 75.453 193.317C75.6511 193.153 75.8644 193.008 76.0899 192.885C76.0503 192.863 76.0253 192.814 75.9949 192.776C74.9253 191.412 74.8623 189.513 75.8394 188.081C76.8164 186.65 78.6081 186.016 80.2678 186.516C81.9275 187.015 83.0725 188.531 83.0979 190.264C84.858 190.005 86.5761 190.947 87.3044 192.57C88.0327 194.193 87.5938 196.103 86.2299 197.245L86.2281 197.248Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0856 190.037C83.1195 190.667 83.0006 191.296 82.739 191.87L83.0856 190.037Z",
    fill: "#FFE2BF"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0856 190.037C83.1195 190.667 83.0006 191.296 82.739 191.87",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1311 193.717C76.6933 193.492 76.309 193.176 76.0044 192.79L77.1311 193.717Z",
    fill: "#FFE2BF"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1311 193.717C76.6933 193.492 76.309 193.176 76.0044 192.79",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5772 198.017C81.8165 197.797 81.1387 197.356 80.6303 196.748C80.4883 196.575 80.3589 196.393 80.243 196.201",
    fill: "#FFE2BF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5772 198.017C81.8165 197.797 81.1387 197.356 80.6303 196.748C80.4883 196.575 80.3589 196.393 80.243 196.201",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7418 219.478C52.4325 221.09 51.1636 222.345 49.5487 222.638C49.797 223.313 49.8548 224.044 49.7157 224.75C49.2345 226.833 47.1923 228.162 45.0929 227.759C42.9936 227.356 41.5888 225.365 41.9129 223.252C41.9628 222.999 42.0367 222.751 42.1337 222.512C42.0861 222.506 42.0391 222.498 41.9929 222.485C40.3 222.107 39.0474 220.676 38.898 218.948C38.7487 217.22 39.7369 215.594 41.3398 214.931C42.9428 214.269 44.7903 214.722 45.9048 216.051C47.1039 214.736 49.0309 214.378 50.6221 215.175C52.2134 215.971 53.0814 217.729 52.7469 219.477L52.7418 219.478Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7485 215.874C46.1726 216.341 46.4779 216.904 46.6385 217.515L45.7485 215.874Z",
    fill: "#FFE2BF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7485 215.874C46.1726 216.341 46.4779 216.904 46.6385 217.515",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4593 222.495C42.9779 222.598 42.48 222.596 41.9995 222.489L43.4593 222.495Z",
    fill: "#FFE2BF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4593 222.495C42.9779 222.598 42.48 222.596 41.9995 222.489",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M50.401 222.385C49.6766 222.695 48.8766 222.783 48.1021 222.639C47.8832 222.597 47.6681 222.537 47.4591 222.459",
    fill: "#FFE2BF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M50.401 222.385C49.6766 222.695 48.8766 222.783 48.1021 222.639C47.8832 222.597 47.6681 222.537 47.4591 222.459",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6255 191.716C70.3161 193.329 69.0467 194.586 67.4306 194.879C67.6789 195.553 67.7373 196.283 67.5994 196.988C67.3739 198.423 66.3845 199.62 65.0185 200.112C63.6525 200.603 62.1271 200.311 61.0393 199.35C59.9516 198.388 59.4745 196.91 59.7948 195.494C59.845 195.241 59.9189 194.993 60.0155 194.753L59.8714 194.725C58.1808 194.344 56.9317 192.912 56.7841 191.185C56.6366 189.458 57.6246 187.835 59.2261 187.173C60.8276 186.511 62.6736 186.962 63.7885 188.289C64.9876 186.974 66.9145 186.616 68.5058 187.413C70.0971 188.21 70.9651 189.967 70.6306 191.715L70.6255 191.716Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6285 188.118C64.062 188.585 64.3734 189.153 64.535 189.769L63.6285 188.118Z",
    fill: "#FFE2BF"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6285 188.118C64.062 188.585 64.3734 189.153 64.535 189.769",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3496 194.737C60.8678 194.841 60.3693 194.84 59.8879 194.734L61.3496 194.737Z",
    fill: "#FFE2BF"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3496 194.737C60.8678 194.841 60.3693 194.84 59.8879 194.734",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2796 194.624C67.5556 194.936 66.7551 195.025 65.9806 194.878C65.7609 194.834 65.5449 194.774 65.3344 194.697",
    fill: "#FFE2BF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2796 194.624C67.5556 194.936 66.7551 195.025 65.9806 194.878C65.7609 194.834 65.5449 194.774 65.3344 194.697",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4179 180.296C88.4482 181.619 86.7655 182.212 85.1803 181.788C85.0252 183.46 83.8371 184.854 82.2114 185.271C80.5857 185.689 78.8728 185.041 77.9311 183.651C76.9894 182.262 77.0218 180.431 78.0122 179.075C78.1649 178.867 78.3373 178.673 78.5268 178.497C78.4872 178.475 78.4443 178.452 78.4105 178.411C77.0439 177.345 76.5257 175.516 77.1299 173.891C77.7341 172.267 79.3214 171.221 81.0527 171.307C82.7841 171.392 84.2602 172.59 84.7009 174.267C86.3472 173.59 88.2424 174.09 89.3404 175.491C90.4384 176.892 90.4715 178.852 89.4215 180.289L89.4179 180.296Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6339 174.052C84.8163 174.656 84.8517 175.294 84.7373 175.914L84.6339 174.052Z",
    fill: "#FFE2BF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6339 174.052C84.8163 174.656 84.8517 175.294 84.7373 175.914",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7367 179.056C79.2576 178.943 78.8081 178.729 78.4182 178.429L79.7367 179.056Z",
    fill: "#FFE2BF"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7367 179.056C79.2576 178.943 78.8081 178.729 78.4182 178.429",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0569 181.92C85.2673 181.885 84.5065 181.614 83.8728 181.141C83.6923 181.008 83.5228 180.861 83.366 180.701",
    fill: "#FFE2BF"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0569 181.92C85.2673 181.885 84.5065 181.614 83.8728 181.141C83.6923 181.008 83.5228 180.861 83.366 180.701",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8028 208.001C53.4924 209.614 52.2234 210.87 50.6078 211.164C50.8572 211.839 50.9167 212.569 50.78 213.275C50.5545 214.71 49.5651 215.907 48.1991 216.399C46.8331 216.89 45.3077 216.598 44.2199 215.637C43.1321 214.675 42.655 213.197 42.9753 211.781C43.0227 211.527 43.0955 211.278 43.1928 211.038L43.052 211.012C41.3611 210.632 40.1111 209.2 39.9627 207.474C39.8142 205.747 40.8015 204.123 42.4027 203.46C44.004 202.797 45.8502 203.248 46.9658 204.574C48.1649 203.259 50.0918 202.901 51.6831 203.698C53.2744 204.495 54.1423 206.252 53.8079 208L53.8028 208.001Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M46.809 204.405C47.2344 204.871 47.5405 205.433 47.7009 206.044L46.809 204.405Z",
    fill: "#FFE2BF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M46.809 204.405C47.2344 204.871 47.5405 205.433 47.7009 206.044",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5235 211.02C44.0422 211.124 43.5441 211.122 43.0637 211.014L44.5235 211.02Z",
    fill: "#FFE2BF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5235 211.02C44.0422 211.124 43.5441 211.122 43.0637 211.014",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4621 210.908C50.739 211.223 49.9375 211.312 49.1631 211.162C48.9437 211.122 48.7285 211.062 48.5201 210.982",
    fill: "#FFE2BF"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4621 210.908C50.739 211.223 49.9375 211.312 49.1631 211.162C48.9437 211.122 48.7285 211.062 48.5201 210.982",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M77.852 174.895C78.6419 176.334 78.4649 178.111 77.4067 179.366C78.8571 180.213 79.6186 181.88 79.3091 183.531C78.9996 185.182 77.6859 186.46 76.0272 186.725C74.3684 186.989 72.7225 186.182 71.9154 184.709C71.7914 184.485 71.691 184.248 71.6159 184.003L71.4861 184.074C69.9414 184.859 68.0658 184.554 66.8504 183.318C65.635 182.083 65.3599 180.203 66.1704 178.671C66.981 177.139 68.6904 176.309 70.3954 176.619C70.4794 174.84 71.7359 173.334 73.4708 172.933C75.2056 172.532 76.9956 173.333 77.852 174.895Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1688 176.584C70.791 176.67 71.383 176.906 71.8936 177.272L70.1688 176.584Z",
    fill: "#FFE2BF"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1688 176.584C70.791 176.67 71.383 176.906 71.8936 177.272",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M72.626 183.139C72.3221 183.525 71.9379 183.841 71.5001 184.064L72.626 183.139Z",
    fill: "#FFE2BF"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M72.626 183.139C72.3221 183.525 71.9379 183.841 71.5001 184.064",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M77.901 178.63C77.5386 179.333 76.9743 179.911 76.2807 180.291C76.0842 180.399 75.8791 180.49 75.6675 180.564",
    fill: "#FFE2BF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M77.901 178.63C77.5386 179.333 76.9743 179.911 76.2807 180.291C76.0842 180.399 75.8791 180.49 75.6675 180.564",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5181 183.936C61.2066 185.548 59.9362 186.804 58.3199 187.097C58.5692 187.771 58.6288 188.502 58.492 189.208C58.2665 190.642 57.2772 191.839 55.9111 192.331C54.5451 192.823 53.0197 192.53 51.9319 191.569C50.8442 190.607 50.3671 189.129 50.6874 187.713C50.7358 187.46 50.8098 187.211 50.9082 186.972L50.764 186.944C49.0731 186.564 47.8232 185.133 47.6747 183.406C47.5263 181.679 48.5135 180.055 50.1148 179.393C51.716 178.73 53.5623 179.18 54.6778 180.507C55.8764 179.188 57.8063 178.827 59.3999 179.625C60.9934 180.423 61.8613 182.184 61.5232 183.934L61.5181 183.936Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M54.521 180.338C54.9465 180.804 55.2525 181.366 55.4129 181.976L54.521 180.338Z",
    fill: "#FFE2BF"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M54.521 180.338C54.9465 180.804 55.2525 181.366 55.4129 181.976",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2356 186.953C51.7537 187.056 51.2554 187.055 50.7739 186.95L52.2356 186.953Z",
    fill: "#FFE2BF"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2356 186.953C51.7537 187.056 51.2554 187.055 50.7739 186.95",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1741 186.841C58.451 187.155 57.6495 187.244 56.8752 187.094C56.6547 187.053 56.4384 186.993 56.2289 186.913",
    fill: "#FFE2BF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1741 186.841C58.451 187.155 57.6495 187.244 56.8752 187.094C56.6547 187.053 56.4384 186.993 56.2289 186.913",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M108.478 184.636L138.77 241.183C139.692 242.907 139.051 245.223 137.275 246.613L98.3071 277.135C96.5241 278.53 94.13 278.597 92.68 277.288L45.0213 234.364L108.478 184.636Z",
    fill: "#FF5986",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M112.633 265.907L103.356 273.174L57.6902 224.435L70.2683 214.577L112.633 265.907Z",
    fill: "white",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M109.194 215.038L132.267 250.524L122.989 257.791L83.2781 204.384L95.8595 194.528L106.557 210.981",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M109.194 215.038L132.267 250.524L122.989 257.791L83.2781 204.384L95.8595 194.528L106.557 210.981",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7778 243.094L89.1481 244.7",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0788 241.521L86.6486 241.92",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5802 245.447L86.981 246.305",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M110.279 183.226L56.3339 225.496L43.4461 235.602C42.762 236.139 41.8924 236.382 41.029 236.277C40.1656 236.172 39.3791 235.729 38.8429 235.044L37.7143 233.607C37.1767 232.922 36.9334 232.051 37.038 231.186C37.1426 230.321 37.5865 229.533 38.272 228.995L105.111 176.623C105.795 176.086 106.665 175.843 107.528 175.948C108.392 176.052 109.178 176.496 109.714 177.181L110.852 178.632C111.961 180.059 111.704 182.115 110.279 183.226Z",
    fill: "#FFB8D2",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M96.022 190.233L101.335 186.068",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8396 235.042L92.8353 192.727",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3591 158.231C76.3554 159.059 74.9466 159.185 73.812 158.549C73.3695 159.806 72.184 160.649 70.8511 160.655C69.5181 160.66 68.3258 159.827 67.8732 158.573C67.4206 157.319 67.8054 155.916 68.8345 155.069C68.9904 154.938 69.1595 154.823 69.3391 154.727C69.3094 154.71 69.2892 154.669 69.2668 154.639C68.4232 153.554 68.3805 152.047 69.1611 150.915C69.9418 149.783 71.3658 149.288 72.6802 149.691C73.9945 150.094 74.8962 151.302 74.9083 152.677C76.3074 152.477 77.6688 153.232 78.2394 154.525C78.81 155.818 78.4502 157.333 77.3591 158.231Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9008 152.496C74.925 152.996 74.8279 153.495 74.6176 153.949L74.9008 152.496Z",
    fill: "#FFE2BF"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9008 152.496C74.925 152.996 74.8279 153.495 74.6176 153.949",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1611 155.385C69.8154 155.207 69.5129 154.956 69.2748 154.648L70.1611 155.385Z",
    fill: "#FFE2BF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1611 155.385C69.8154 155.207 69.5129 154.956 69.2748 154.648",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4521 158.834C73.8504 158.657 73.3157 158.304 72.9169 157.819C72.8048 157.681 72.7026 157.535 72.6111 157.382",
    fill: "#FFE2BF"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4521 158.834C73.8504 158.657 73.3157 158.304 72.9169 157.819C72.8048 157.681 72.7026 157.535 72.6111 157.382",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8375 151.042C57.8361 151.866 56.4316 151.991 55.3006 151.357C55.113 151.893 54.7812 152.368 54.3416 152.729C53.4207 153.491 52.1468 153.665 51.0555 153.177C49.9641 152.688 49.2446 151.623 49.1994 150.428C49.1542 149.234 49.7911 148.117 50.8424 147.547C50.8127 147.531 50.7958 147.491 50.7701 147.46C49.9327 146.377 49.8931 144.876 50.6721 143.751C51.4512 142.625 52.8696 142.134 54.1781 142.536C55.4866 142.938 56.3838 144.142 56.3959 145.511C57.7886 145.313 59.1429 146.065 59.7109 147.352C60.2789 148.639 59.9221 150.147 58.8375 151.042Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3847 145.336C56.4073 145.833 56.3103 146.329 56.1019 146.781L56.3847 145.336Z",
    fill: "#FFE2BF"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3847 145.336C56.4073 145.833 56.3103 146.329 56.1019 146.781",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 148.214C51.3194 148.035 51.0172 147.783 50.7779 147.477L51.6641 148.214Z",
    fill: "#FFE2BF"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 148.214C51.3194 148.035 51.0172 147.783 50.7779 147.477",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9426 151.639C55.3422 151.462 54.8086 151.109 54.4107 150.626C54.2957 150.489 54.1923 150.342 54.1016 150.187",
    fill: "#FFE2BF"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9426 151.639C55.3422 151.462 54.8086 151.109 54.4107 150.626C54.2957 150.489 54.1923 150.342 54.1016 150.187",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8483 173.468C52.8496 174.296 51.4439 174.423 50.313 173.788C49.8453 175.109 48.5588 175.961 47.1598 175.875C45.7608 175.789 44.5879 174.787 44.285 173.419C43.9821 172.05 44.6226 170.646 45.8547 169.978C45.825 169.962 45.8048 169.921 45.7824 169.891C44.9425 168.809 44.9009 167.307 45.6796 166.18C46.4582 165.053 47.8775 164.56 49.1869 164.963C50.4964 165.365 51.3939 166.57 51.4049 167.94C52.7962 167.744 54.1487 168.495 54.7167 169.78C55.2847 171.065 54.9301 172.572 53.8483 173.468Z",
    fill: "#FFE2BF",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8483 173.468C52.8496 174.296 51.4439 174.423 50.313 173.788C49.8453 175.109 48.5588 175.961 47.1598 175.875C45.7608 175.789 44.5879 174.787 44.285 173.419C43.9821 172.05 44.6226 170.646 45.8547 169.978C45.825 169.962 45.8048 169.921 45.7824 169.891C44.9425 168.809 44.9009 167.307 45.6796 166.18C46.4582 165.053 47.8775 164.56 49.1869 164.963C50.4964 165.365 51.3939 166.57 51.4049 167.94C52.7962 167.744 54.1487 168.495 54.7167 169.78C55.2847 171.065 54.9301 172.572 53.8483 173.468Z",
    fill: "#FFBA68",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4007 167.76C51.4232 168.258 51.3263 168.753 51.1179 169.205L51.4007 167.76Z",
    fill: "#FFE2BF"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4007 167.76C51.4232 168.258 51.3263 168.753 51.1179 169.205",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6786 170.634C46.3336 170.454 46.0314 170.203 45.7923 169.896L46.6786 170.634Z",
    fill: "#FFE2BF"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6786 170.634C46.3336 170.454 46.0314 170.203 45.7923 169.896",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9605 174.06C50.3596 173.885 49.8253 173.533 49.4267 173.05C49.3149 172.913 49.2138 172.768 49.1241 172.615",
    fill: "#FFE2BF"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9605 174.06C50.3596 173.885 49.8253 173.533 49.4267 173.05C49.3149 172.913 49.2138 172.768 49.1241 172.615",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M271.227 103.516L272.963 107.738C273.02 107.88 273.144 107.984 273.295 108.015L285.52 110.67C285.569 110.68 285.608 110.717 285.62 110.765C285.632 110.814 285.616 110.865 285.578 110.897L276.033 118.966C275.916 119.065 275.855 119.214 275.87 119.366L277.126 131.77C277.133 131.821 277.109 131.871 277.065 131.897C277.021 131.924 276.966 131.922 276.924 131.893L266.275 125.329C266.144 125.249 265.983 125.237 265.843 125.299L254.389 130.315C254.344 130.336 254.29 130.33 254.251 130.298C254.212 130.266 254.195 130.215 254.207 130.166L257.177 118.057C257.214 117.909 257.175 117.752 257.073 117.638L248.738 108.321C248.705 108.284 248.696 108.231 248.714 108.185C248.733 108.139 248.777 108.107 248.826 108.104L261.305 107.177C261.458 107.167 261.596 107.081 261.672 106.949L267.975 96.178C268.001 96.135 268.048 96.11 268.098 96.1135C268.147 96.117 268.191 96.1483 268.21 96.1943L270.722 102.309",
    fill: "#47DDDF"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M271.227 103.516L272.963 107.738C273.02 107.88 273.144 107.984 273.295 108.015L285.52 110.67C285.569 110.68 285.608 110.717 285.62 110.765C285.632 110.814 285.616 110.865 285.578 110.897L276.033 118.966C275.916 119.065 275.855 119.214 275.87 119.366L277.126 131.77C277.133 131.821 277.109 131.871 277.065 131.897C277.021 131.924 276.966 131.922 276.924 131.893L266.275 125.329C266.144 125.249 265.983 125.237 265.843 125.299L254.389 130.315C254.344 130.336 254.29 130.33 254.251 130.298C254.212 130.266 254.195 130.215 254.207 130.166L257.177 118.057C257.214 117.909 257.175 117.752 257.073 117.638L248.738 108.321C248.705 108.284 248.696 108.231 248.714 108.185C248.733 108.139 248.777 108.107 248.826 108.104L261.305 107.177C261.458 107.167 261.596 107.081 261.672 106.949L267.975 96.178C268.001 96.135 268.048 96.11 268.098 96.1135C268.147 96.117 268.191 96.1483 268.21 96.1943L270.722 102.309",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5818 281.212L51.0289 283.101C51.1105 283.165 51.2188 283.183 51.3175 283.151L59.3849 280.568C59.4171 280.558 59.4523 280.566 59.4758 280.591C59.4993 280.615 59.507 280.65 59.4956 280.682L56.6303 288.645C56.5954 288.742 56.6103 288.851 56.6702 288.935L61.6061 295.783C61.6272 295.81 61.63 295.848 61.6134 295.878C61.5968 295.908 61.5638 295.926 61.5293 295.923L53.0626 295.679C52.959 295.676 52.8604 295.725 52.7989 295.808L47.7813 302.627C47.7617 302.655 47.7279 302.669 47.6942 302.664C47.6606 302.658 47.6332 302.634 47.6237 302.601L45.2662 294.496C45.2376 294.396 45.1617 294.318 45.0634 294.285L37.0215 291.643C36.9894 291.633 36.9662 291.605 36.9616 291.572C36.9571 291.538 36.9719 291.505 36.9999 291.486L44.0031 286.718C44.0895 286.661 44.1413 286.564 44.1412 286.46L44.191 278.01C44.1912 277.977 44.2105 277.946 44.2409 277.931C44.2713 277.916 44.3074 277.92 44.334 277.941L47.8773 280.675",
    fill: "#62A3FF"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5818 281.212L51.0289 283.101C51.1105 283.165 51.2188 283.183 51.3175 283.151L59.3849 280.568C59.4171 280.558 59.4523 280.566 59.4758 280.591C59.4993 280.615 59.507 280.65 59.4956 280.682L56.6303 288.645C56.5954 288.742 56.6103 288.851 56.6702 288.935L61.6061 295.783C61.6272 295.81 61.63 295.848 61.6134 295.878C61.5968 295.908 61.5638 295.926 61.5293 295.923L53.0626 295.679C52.959 295.676 52.8604 295.725 52.7989 295.808L47.7813 302.627C47.7617 302.655 47.7279 302.669 47.6942 302.664C47.6606 302.658 47.6332 302.634 47.6237 302.601L45.2662 294.496C45.2376 294.396 45.1617 294.318 45.0634 294.285L37.0215 291.643C36.9894 291.633 36.9662 291.605 36.9616 291.572C36.9571 291.538 36.9719 291.505 36.9999 291.486L44.0031 286.718C44.0895 286.661 44.1413 286.564 44.1412 286.46L44.191 278.01C44.1912 277.977 44.2105 277.946 44.2409 277.931C44.2713 277.916 44.3074 277.92 44.334 277.941L47.8773 280.675",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M344.589 350.535L344.823 348.791C344.831 348.733 344.81 348.674 344.766 348.635L341.196 345.393C341.182 345.38 341.176 345.36 341.181 345.341C341.187 345.323 341.202 345.309 341.221 345.306L345.962 344.452C346.02 344.441 346.069 344.403 346.094 344.35L348.065 339.967C348.072 339.949 348.09 339.937 348.109 339.937C348.129 339.936 348.147 339.947 348.155 339.965L350.445 344.208C350.473 344.26 350.525 344.295 350.584 344.302L355.373 344.835C355.392 344.836 355.409 344.849 355.416 344.867C355.423 344.885 355.419 344.906 355.405 344.92L352.08 348.389C352.04 348.431 352.022 348.491 352.034 348.549L353.021 353.265C353.025 353.284 353.018 353.303 353.003 353.315C352.987 353.327 352.967 353.329 352.95 353.32L348.606 351.225C348.553 351.199 348.49 351.201 348.439 351.23L344.26 353.611C344.243 353.62 344.223 353.619 344.207 353.609C344.191 353.598 344.182 353.579 344.185 353.56L344.524 351.035",
    fill: "#C0FF97"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M344.589 350.535L344.823 348.791C344.831 348.733 344.81 348.674 344.766 348.635L341.196 345.393C341.182 345.38 341.176 345.36 341.181 345.341C341.187 345.323 341.202 345.309 341.221 345.306L345.962 344.452C346.02 344.441 346.069 344.403 346.094 344.35L348.065 339.967C348.072 339.949 348.09 339.937 348.109 339.937C348.129 339.936 348.147 339.947 348.155 339.965L350.445 344.208C350.473 344.26 350.525 344.295 350.584 344.302L355.373 344.835C355.392 344.836 355.409 344.849 355.416 344.867C355.423 344.885 355.419 344.906 355.405 344.92L352.08 348.389C352.04 348.431 352.022 348.491 352.034 348.549L353.021 353.265C353.025 353.284 353.018 353.303 353.003 353.315C352.987 353.327 352.967 353.329 352.95 353.32L348.606 351.225C348.553 351.199 348.49 351.201 348.439 351.23L344.26 353.611C344.243 353.62 344.223 353.619 344.207 353.609C344.191 353.598 344.182 353.579 344.185 353.56L344.524 351.035",
    stroke: "#0D052C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.40de8e861ccc54f38724bebe08b37f16.svg";
export { ForwardRef as ReactComponent };